import actions from './actions';
import { createReducer, getError } from '../../../../../helpers/reducer';
import { keyBy } from '../../../../../helpers/core';

const initState = {
  editForm: null,
  loading: false,
  saved: false,
  formInfo: null,
};

const initialAccreditationData = {
  accreditation: null,
  status: null,
  expiry: null,
  document_images: [],
};

function validate(/* attr, value */) {
  return '';
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const propsArray = Object.keys(data);

  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      // eslint-disable-next-line no-prototype-builtins
      value: data[prop] && data[prop].hasOwnProperty('id') ? data[prop].id : data[prop],
      error: validate(prop, data[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    loading: false,
    editForm: {
      ...editForm,
    },
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  let { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  if (attr === 'accreditation') {
    const propsArray = Object.entries(editForm);
    editForm = keyBy(
      propsArray,
      entry => entry[0],
      entry => {
        // eslint-disable-next-line no-shadow
        const [, value] = entry;

        return {
          ...value,
          error: '',
          touched: false,
        };
      },
    );
  }

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onSaveSuccess(state) {
  return {
    ...state,
    saved: true,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        error: getError(entry[0], data),
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onAddSuccess(state) {
  return {
    ...state,
    saved: true,
  };
}

function onCreate(state) {
  const propsArray = Object.keys(initialAccreditationData);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: prop === 'document_images' ? [] : initialAccreditationData[prop],
      error: '',
      touched: false,
    }),
  );

  return {
    ...state,
    loading: true,
    editForm,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onLoadFormData(state, { payload }) {
  const { data } = payload;

  return {
    ...state,
    loading: false,
    formInfo: data,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.ADD_SUCCESS]: onAddSuccess,
  [actions.CREATE]: onCreate,
  [actions.TOUCH]: onTouch,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
});
